var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLongArrow = function SvgLongArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 800 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m781.6 32-2.2-2.1 8.8-8.4H0v-3h788.2l-8.8-8.4 2.2-2.1L794 20l-12.4 12Z"
  })));
};
export default SvgLongArrow;